require('./brokerStocksAdvancedBuyStep3.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @commons
const AdvancedBuySellStockSummary = require('components/broker/commons/advancedBuySellStockSummary/advancedBuySellStockSummary');
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { LoadingSection } = require('commonsComponents/loadingSection');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const BrokerStocksAdvancedBuyExanteCost = require('./brokerStocksAdvancedBuyExanteCost/brokerStocksAdvancedBuyExanteCost')

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    SECOND_STEP,
    CHARGE_ACCOUNT_PREFIX,
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
    BROKER_MIFID_VERSION_1,
} = require('constants/index');

const {
    STOCKS_BUY_SHOW_PROFITABILITY,
} = require('constants/flagBasedFeatures');

const { BROKER_STOCKS_ADVANCED_BUY_ID } = require('constants/operationTypes');

class BrokerStocksAdvancedBuyStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.buildMiFIDDisclaimer = this.buildMiFIDDisclaimer.bind(this);
    }

    componentDidMount() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const usingMifidv1 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_1;

        if (usingMifidv1) {
            const productId = BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID;
            this.props.onFetchBrokerMiFIDProduct(productId);
        }
        this.props.getExtantCostDetails();
    }

    buildDisclaimerITF() {
        return (<React.Fragment>
            <div className="stocks-advanced-buy-step3__disclaimer">
                <OKMessage
                    id="stocks-advanced-buy-step3-disclaimer"
                    type="informative"
                    visible={true}
                >
                    <FormattedText value="broker-stocksBuyStep2DisclaimerParagraph1" />
                    <FormattedText value="broker-stocksBuyStep2DisclaimerParagraph2" />
                    <div><FormattedText value="broker-stocksBuyStep2DisclaimerParagraph3" /></div>

                </OKMessage>
            </div>
            <ContactCenterRender>
                <div className="stocks-advanced-buy-step3__disclaimer">
                    <BlockInfo>
                        <FormattedText
                            className="stocks-advanced-buy-step3__disclaimer-title"
                            value="broker-stocksBuyStep2DisclaimerITFTitle"
                        />
                        <FormattedText
                            value="broker-stocksBuyStep2DisclaimerITFDescription"
                        />
                    </BlockInfo>
                </div>
            </ContactCenterRender>
        </React.Fragment>);
    }

    buildMiFIDDisclaimer() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts } = this.props;
        const usingMifidv1 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_1;

        if (usingMifidv1) {
            const mifidProductsLoading = immBrokerMiFIDProducts.getIn([
                'products',
                BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
                'loading'
            ]);

            let mifidDisclaimer;

            if (mifidProductsLoading) {
                mifidDisclaimer = <LoadingSection/>;
            } else {
                mifidDisclaimer = immBrokerMiFIDProducts.getIn([
                    'products',
                    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
                    'disclaimer'
                ]);
            }

            return (
                <section className="stocks-advanced-buy-step3__section">
                    <h2 className="stocks-advanced-buy-step3__section-title stocks-advanced-buy-step3__clause-section-title">
                        <FormattedText value="broker-stocksAdvancedBuyStep3ClauseSectionLabel" />
                    </h2>
                    <section className="stocks-advanced-buy-step3__clause-section-info-container">
                        <p className="stocks-advanced-buy-step3__clause-section-info">
                            {mifidDisclaimer}
                        </p>
                    </section>
                </section>
            );
        }
    }

    buildDataSection() {
        const {
            flagBasedFeatures,
            immStocksContract,
            immSearchState,
            immProductFile,
            immBrokerStocksAdvancedBuy
        } = this.props;

        const showExantCost = flagBasedFeatures.get('wealth_stocks_buy_show_costs');
        const showProfitabilitySection = flagBasedFeatures.get(STOCKS_BUY_SHOW_PROFITABILITY);

        return showExantCost
            ? (
                <div>
                    <BrokerStocksAdvancedBuyExanteCost
                        immProductFile={immProductFile}
                        immBrokerStocksAdvancedBuy={immBrokerStocksAdvancedBuy}
                        immStocksContract={immStocksContract}
                        showProfitabilitySection={showProfitabilitySection}
                        immSearchState={immSearchState}
                    />
                </div>
            ) : (
                <AdvancedBuySellStockSummary
                    immProductFile={immProductFile}
                    immBrokerStocksAdvancedState={immBrokerStocksAdvancedBuy}
                    immStocksContract={immStocksContract}
                    immSearchState={immSearchState}
                    modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER}
                />
            )
    }

    render() {
        const {
            immProductFile,
            immBrokerStocksAdvancedBuy,
            immStocksContract,
        } = this.props;

        const step2 = immBrokerStocksAdvancedBuy.getIn(['steps', SECOND_STEP]);
        const selectedOptionValue = step2.get('selectedOptionValue');
        const selectedStockContract = immStocksContract.get(selectedOptionValue);
        const operationParams = {
            chargeAccount: CHARGE_ACCOUNT_PREFIX + selectedStockContract.get('productNumber') + selectedStockContract.get('walletNumber'),
            bondsNumber: immBrokerStocksAdvancedBuy.getIn(['validationServiceResponse', 'ntitulos'])
        };
        const operative = formatText('operatives-stocksAdvancedBuy');

        const disclaimerITF = immProductFile.get('itf') ? this.buildDisclaimerITF() : null;

        return (
            <div className="stocks-advanced-buy-step3">
                <header className="stocks-advanced-buy-step3__header">
                    <h2 className="stocks-advanced-buy-step3__header-title">
                        {formatText('broker-stocksAdvancedBuyStep3HeaderTitle')}
                    </h2>
                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>
                    <p className="stocks-advanced-buy-step3__header-text">
                        {formatText('broker-stocksAdvancedBuyStep3HeaderText')}
                    </p>
                </header>
                {this.buildDataSection()}
                {this.buildMiFIDDisclaimer()}
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                <footer className="stocks-advanced-buy-step3__section no-print-out">
                    <SignaturePattern
                        operationType={BROKER_STOCKS_ADVANCED_BUY_ID}
                        operationParams={operationParams}
                    />
                    {disclaimerITF}
                </footer>
            </div>
        );
    }
}

BrokerStocksAdvancedBuyStep3.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerStocksAdvancedBuy: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    immSearchState: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    onFetchBrokerMiFIDProduct: PropTypes.func.isRequired,
    getExtantCostDetails: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = BrokerStocksAdvancedBuyStep3;
